import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const CustomDropdown = (props) => {
  // console.log("DROPPROPD", props);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const dropdownitems = props.dropdownitems;
  const listItems = dropdownitems.map((items) => (
    <DropdownItem onClick={() => props.changeLanguage(items.code)}>
      <span>
        <img src={items.img} className="img-fluid mr-2 flagImage" alt="img" />
      </span>
      {items.innertitle}
    </DropdownItem>
  ));

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      className={`custom-dropdown ${props.uniqueClass}`}
    >
      <DropdownToggle tag="a" caret color="transparent">
        {props.maintitle}
      </DropdownToggle>
      <DropdownMenu className="custom-dropdown-block">{listItems}</DropdownMenu>
    </Dropdown>
  );
};

CustomDropdown.defaultProps={
  changeLanguage: () =>{}
}

export default CustomDropdown;
